import { Component, ReactNode } from 'react';

type ErrorBoundaryProps = {
  children: ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
  error?: Error;
};

export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: any) {
    // Log to console for now; could integrate with monitoring later
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReset = () => {
    // Simple reset: reload the page to recover from transient DOM mismatch
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-white">
          <div className="max-w-md text-center p-6">
            <h2 className="text-2xl font-bold mb-3">Si è verificato un errore</h2>
            <p className="text-gray-600 mb-4">
              Abbiamo riscontrato un problema durante il rendering della pagina. Prova ad aggiornare.
            </p>
            <button
              onClick={this.handleReset}
              className="inline-flex items-center rounded-md bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
            >
              Aggiorna pagina
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}